<template>
  <div class="main writeUpgradeMain">
    <!-- 顶部 -->
    <div class="top">
      <img class="goback" src="../assets/back.png" @click="goback">
      <span>返回</span>
      <span class="writeUpgrade">填写升级申报材料</span>
    </div>
    <div style="margin: 0 10px;">
      <Declaration :isShowBtn="true" :form="formData" :awardList="awardList" :isDisabled="false" :isPreview="false"></Declaration>
    </div>
  </div>
</template>

<script>
import Declaration from '../components/Declaration'
import * as API from '../utils/apiService'
export default {
  components: {
    Declaration
  },
  data () {
    return {
      awardList: [
        {
          bear_palm_time: '',
          bear_palm_name: '',
          bear_palm_grade: '',
          bear_palm_branch: ''
        }
      ],
      formData: {
        constructioncompanyList: [
          { construction_company_name: '' }
        ],
        unitecompanyList: [
          {
            unite_company_name: ''
          }
        ],
        items_name: '', // 申报项目名称
        company_name: '', // 主申报单位
        construction_place: '', // 项目建设地点
        construction_time: '', // 项目竣工时间
        address: '', // 联系地址
        legal_person: '', // 主申报单位法人
        legal_person_phone: '', // 电话
        linkman: '', // 联系人
        position: '', // 职务
        email: '', // 邮箱
        cellphone: '', // 手机
        telephone: '', // 座机
        fax: '', // 传真
        award: '', // 现有评定类型
        award_type: 3, // 申报评定类型
        project_type: [], // 项目类型
        overview: '', // 项目概况
        benefit: '', // 社会效益和经济效益
        operability: '', // 可操作性和示范性
        overviewPICs: [], // 项目概况图片
        benefitPICs: [], // 社会效益和经济效益图片
        operabilityPICs: [], // 可操作性和示范性图片
        overviewPIC: [], // 请求返回的项目概况图片路径集合
        benefitPIC: [], // 请求返回的社会效益和经济效益图片路径集合
        operabilityPIC: [] // 请求返回的可操作性和示范性图片路径集合
      }
    }
  },
  mounted () {
    let params = {
      id: this.$route.query.id
    }
    API.getEBByID(params).then(resp => {
      if (resp.resultCode === '0000') {
        this.formData = {
          ...resp.data,
          award_type: resp.data.award === 1 ? 1 : resp.data.award === 0 ? 3 : resp.data.award - 1,
          overviewPICs: [],
          benefitPICs: [],
          operabilityPICs: [],
          overviewPIC: [],
          benefitPIC: [],
          operabilityPIC: [],
          project_type: resp.data.project_type ? resp.data.project_type.split(',') : [],
          unitecompanyList: resp.data.unite_company_name.split(',').map(item => ({ unite_company_name: item })),
          constructioncompanyList: resp.data.construction_company_name.split(',').map(item => ({ construction_company_name: item }))
        }
        this.awardList = !resp.data.projectWinHistoryDtos.length ? [
          {
            bear_palm_time: '',
            bear_palm_name: '',
            bear_palm_grade: '',
            bear_palm_branch: ''
          }
        ] : resp.data.projectWinHistoryDtos
      }
    })
  },
  methods: {
    goback () {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss">
.writeUpgradeMain {
  .writeUpgrade {
    color: #00b0f0;
    font-size: 20px;
    font-weight: 500;
    margin-left: 35%;
  }
}
</style>
